import { render } from "./FormVerifikasiHps.vue?vue&type=template&id=1453d273"
import script from "./FormVerifikasiHps.vue?vue&type=script&lang=js"
export * from "./FormVerifikasiHps.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__